import { z } from "zod";
export const paginationMetaSchema = z.object({
    page: z.number().int().positive(),
    perPage: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    hasNextPage: z.boolean(),
});
/** Build a `Paginated` envelope from a raw page of results. */
export function paginated(items, meta) {
    return { items, meta };
}
//# sourceMappingURL=pagination.js.map